import React from "react";
import { NotationRenderer } from "./Renderer.component";
import { useStore } from "../../store";

const mapStoreToProps = (state, dispatch, props) => {
    return {
        height: props.height,
        width: props.width,
        variation: props.variation,
    };
};

export const RendererContainer = (props) => {
    const { state, dispatch } = useStore();
    const sliderRef = React.useRef(null);

    React.useEffect(() => {
        const keyUpListener = (event) => {
            // Enter or Right Arrow = Next page
            if (
                event.code === "Enter" ||
                event.code === "ArrowRight" ||
                event.keyCode === 13 ||
                event.keyCode === 39
            ) {
                event.preventDefault();
                sliderRef.current && sliderRef.current.slickNext();
            }
            // Backspace or Left Arrow = Previous page
            if (
                event.code === "Backspace" ||
                event.code === "ArrowLeft" ||
                event.keyCode === 8 ||
                event.keyCode === 37
            ) {
                event.preventDefault();
                sliderRef.current && sliderRef.current.slickPrev();
            }
        };

        window.addEventListener("keyup", keyUpListener);

        // Cleanup: remove listener when component unmounts
        return () => {
            window.removeEventListener("keyup", keyUpListener);
        };
    }, []);

    return (
        <NotationRenderer
            ref={sliderRef}
            {...mapStoreToProps(state, dispatch, props)}
        />
    );
};
